<template>
    <div class="panel__container">
        <users-table v-if="showUsers" :users="users">
            <table slot="title">Manage people</table>
            <template v-if="currentUser.is_not_guest" slot="header">
                <router-link :to="{ name: 'people.options', params: { channel: channel.slug }}" data-locator="invite-guests" class="button button--small button--primary button--icon panel__button">
                    <span>Add people</span>
                    <icon type="circle-plus" color="white" size="12" />
                </router-link>
            </template>
            <template v-slot="{ user }">
                <more-navigation v-slot="scope" orientation="horizontal">
                    <li class="dropdown-menu__item">
                        <a href="#" @click.prevent="removeUser(user, scope)" data-locator="remove" class="dropdown-menu__link">Remove</a>
                    </li>
                </more-navigation>
            </template>
        </users-table>

        <confirm ref="confirmRemoval" @shown="showUsers = false" @hidden="showUsers = true">
            <h3 slot="title" class="confirmation__title">Remove person</h3>
            Are you sure you want to remove this person from {{ channel.name }}?
        </confirm>
    </div>
</template>
<script>
/* global EventBus */
import { mapState, mapGetters } from 'vuex'
import Confirm from '../../../Global/Confirm'
import Icon from '../../../Global/Icon'
import UsersTable from '../../../Global/Users/UsersTable'
import MoreNavigation from '../../../Global/MoreNavigation'
import currentTenantAware from '../../../../mixins/currentTenantAware'

export default {
    mixins: [currentTenantAware],

    data () {
        return {
            query: '',
            showUsers: true
        }
    },

    methods: {
        manageUser () {
            this.$emit('invite')
        },

        removeUser (user, menu) {
            this.$refs.confirmRemoval.show(user.display_name, () => {
                return this.$store.dispatch('channel/removeMember', user).then(() => {
                    this.maybeRedirectAway(user)
                    EventBus.$emit('newSnackbar', `${user.display_name ? user.display_name : user.email} removed from ${this.channel.name}`)
                })
            })

            menu.close()
        },

        maybeRedirectAway (user) {
            if (this.currentUser.id === user.id) {
                let channel = this.activeCurrentUserChannels.filter(channel => channel.id !== this.channel.id)[0]

                window.location.replace(channel ? channel.url : '/')
            }
        }
    },

    computed: {
        ...mapState('users', {
            currentUser: 'current'
        }),

        ...mapState('channel', ['channel']),

        ...mapGetters({
            users: 'channel/sortedPeople',
            activeCurrentUserChannels: 'activeCurrentUserChannels'
        })
    },

    components: {
        Confirm,
        UsersTable,
        MoreNavigation,
        Icon
    }
}
</script>
